import styled from 'styled-components';

export const Heading = styled.h1`
  color: #212121;
  margin: 45px 0 20px 0;
`;
